import request from './request';

export function getData(params) {
	return request({
		url: '/dg/driver/search/pr',
		method: 'post',
		data: params
	});
}
